<!-- libs/features/global-search/feature-global-search/src/lib/components/result-items/cycle-result-item/cycle-result-item.component.html -->

@if (item()) {
	<!-- Check if item input is resolved -->
	<div class="item-container">
		<div class="flex flex-col justify-between">
			<span class="font-semibold text-blue-600 flex items-center">
				<icon
					[icon]="'fas fa-file-alt'"
					class="mx-2 text-gray-500"
				/>
				<span>{{ item().name || 'שם מסמך לא זמין' }}</span>
			</span>
			<!-- Creator and Status -->
			<div class="text-xs text-gray-500">
				<!-- Accessing name from nested userModel (assuming 'name' property exists) -->
				<span>
					{{ 'pages.cycles.creator' | translate }}: {{ item().userModel?.displayName || ('struct.flowchart.message.unknown' | translate) }} | {{ 'pages.cycles.status.label' | translate }}:
					<span
						class="font-medium"
						[class.text-green-600]="item().status === CycleStatusType.Completed"
						[class.text-orange-600]="item().archive === true"
						[class.text-red-600]="item().status === CycleStatusType.Denied || item().status === CycleStatusType.Canceled"
						[class.text-gray-600]="!item().archive && item().status !== CycleStatusType.Completed && item().status !== CycleStatusType.Denied && item().status !== CycleStatusType.Canceled"
					>
						@let cycleStatusData = getCycleStatusData(item().status);
						@if (cycleStatusData) {
							<span [style.color]="`var(${cycleStatusData.colors})`">{{ cycleStatusData.label | translate }}</span>
							@if (item().archive) {
								(בארכיון)
							}
						}
					</span>
				</span>
			</div>
		</div>

		<span class="cycle-dates">
			<!-- File type removed as it's not in ICycle -->
			<!-- Display creation date -->
			<span> {{ 'pages.cycles.createdat' | translate }}: {{ (creationDate$() | date: 'dd.MM.yyyy HH:mm') || 'לא ידוע' }} </span>
			<!-- Display last update date -->
			<span> {{ 'pages.cycles.updatedat' | translate }}: {{ (item().lastUpdate | date: 'dd.MM.yyyy HH:mm') || 'לא ידוע' }}</span>
		</span>
	</div>
} @else {
	<!-- Optional: Placeholder if item is somehow null/undefined initially -->
	<div class="p-4 border rounded-md animate-pulse bg-gray-100">
		<div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
		<div class="h-3 bg-gray-300 rounded w-1/2"></div>
	</div>
}
